import { registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import en from '@angular/common/locales/en';
import vi from '@angular/common/locales/vi';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import player from 'lottie-web';
import { provideNzI18n, vi_VN } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { provideLottieOptions } from 'ngx-lottie';
import { provideQuillConfig } from 'ngx-quill';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { icons } from './icons-provider';
import { httpInterceptor } from './interceptors/http.interceptor';
import { LinkedOaSyncService } from './pages/chat/services/linked-oa-sync.service';
import { ConsoleCaptureService } from './services/console-capture.service';
import { UsageSenderService } from './services/usage-tracking/usage-sender.service';
import { UsageTrackerService } from './services/usage-tracking/usage-tracker.service';
// import { LogSdkService } from './services/log-sdk.service';
// Factory function để tạo TranslateLoader

const basePath = window.location.pathname.includes('s-o-t') ? '/s-o-t/' : '/';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${basePath}assets/i18n/`, '.json');
}

registerLocaleData(en);
registerLocaleData(vi);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideNzIcons(icons),
    provideNzI18n(vi_VN),
    importProvidersFrom(
      FormsModule,
      NzModalModule,
      TranslateModule.forRoot({
        defaultLanguage: 'vi',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAnimationsAsync(),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),

    provideServiceWorker('service-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideLottieOptions({
      player: () => player,
    }),
    provideQuillConfig({
      modules: {
        toolbar: [
          ['bold', 'italic', 'strike'],
          ['code'],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ],
      },
      theme: 'bubble',
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (consoleCapture: ConsoleCaptureService) => () => {
        consoleCapture.start();
      },
      deps: [ConsoleCaptureService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (usageSender: UsageSenderService, usageTracker: UsageTrackerService) => () => {
        void usageSender.start();
        void usageTracker.start();
      },
      deps: [UsageSenderService, UsageTrackerService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (linkedOaSync: LinkedOaSyncService) => () => {
        void linkedOaSync.resumeOnStartup();
      },
      deps: [LinkedOaSyncService],
      multi: true,
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (logSdk: LogSdkService) => () => {
    //     logSdk.init();
    //   },
    //   deps: [LogSdkService],
    //   multi: true,
    // },
  ],
};
